import React from 'react';

const PackageSendingProcedures = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-4">Package Sending Rules for XGO Life App</h1>
      <p className="mb-4">Last Updated: February 6, 2025</p>

      <h2 className="text-2xl font-semibold mt-6">Introduction</h2>
      <p className="mb-4">
        To ensure rules for sending packages, users can ensure a smooth and efficient shipping experience with the Xgo Life App.
      </p>

      <h2 className="text-2xl font-semibold">1. Package Preparation</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Proper Packaging:</strong> Ensure that all items are securely packaged to prevent damage during transit. Use appropriate materials such as bubble wrap, packing peanuts, or sturdy boxes.</li>
        <li><strong>Labeling:</strong> Clearly label each package with the recipient's name, address, and contact number. Include a return address to facilitate returns if necessary.</li>
      </ul>

      <h2 className="text-2xl font-semibold">2. Prohibited Items</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Restricted Items:</strong> Do not send items that are prohibited by law or by the Xgo Life App’s policies. This includes, but is not limited to, hazardous materials, perishable goods, and illegal substances.</li>
        <li><strong>Check Regulations:</strong> Familiarize yourself with any specific regulations regarding the shipment of certain items, especially in different regions or countries.</li>
      </ul>

      <h2 className="text-2xl font-semibold">3. Weight and Size Limits</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Adhere to Limits:</strong> Ensure that the package complies with the weight and size limits set by the Xgo Life App. Check the app or website for specific guidelines.</li>
        <li><strong>Handling Considerations:</strong> Be mindful of the handling requirements for larger or heavier packages, and consider whether additional resources are needed for transportation.</li>
      </ul>

      <h2 className="text-2xl font-semibold">4. Documentation</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Required Paperwork:</strong> Complete any necessary documentation for the shipment, including invoices, customs declarations (for international shipments), and tracking information.</li>
        <li><strong>Proof of Value:</strong> For high-value items, consider including proof of value documentation to facilitate insurance claims if needed.</li>
      </ul>

      <h2 className="text-2xl font-semibold">5. Scheduling Pickups</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Use the App:</strong> Schedule package pickups through the Xgo Life App, ensuring that all details are filled out accurately.</li>
        <li><strong>Pickup Availability:</strong> Confirm the availability of pickup times and be present at the designated location during the scheduled time.</li>
      </ul>

      <h2 className="text-2xl font-semibold">6. Insurance and Liability</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Optional Insurance:</strong> Consider purchasing additional insurance for valuable or fragile items to protect against loss or damage during transit.</li>
        <li><strong>Understand Liability:</strong> Be aware of the liability limitations set forth by the Xgo Life App in case of lost or damaged packages.</li>
      </ul>

      <h2 className="text-2xl font-semibold">7. Tracking and Communication</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Tracking Information:</strong> Use the tracking feature in the app to monitor the status of your package throughout its journey.</li>
        <li><strong>Customer Communication:</strong> Keep the recipient informed about the shipping status and provide tracking details to ensure they can anticipate the delivery.</li>
      </ul>

      <h2 className="text-2xl font-semibold">8. Delivery Confirmation</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Request Confirmation:</strong> For important or high-value shipments, consider requesting delivery confirmation to ensure that the package has been received by the intended recipient.</li>
        <li><strong>Follow Up:</strong> If there are any issues with delivery, follow up promptly to address any concerns or discrepancies.</li>
      </ul>

      <h2 className="text-2xl font-semibold">9. Feedback and Reporting Issues</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Provide Feedback:</strong> After sending a package, provide feedback on your experience to help improve the service.</li>
        <li><strong>Report Problems:</strong> If any issues arise during the shipping process (such as delays or damages), report them through the app immediately for resolution.</li>
      </ul>
    </div>
  );
};

export default PackageSendingProcedures;